import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Plus } from 'lucide-react';

const fields = [
  { key: 'name', label: 'Name *', testId: 'worker-name-input', placeholder: 'Enter worker name' },
  { key: 'phone', label: 'Phone *', testId: 'worker-phone-input', placeholder: 'Enter phone number' },
  { key: 'daily_wage', label: null, testId: 'worker-wage-input', placeholder: 'Enter daily wage', type: 'number' },
  { key: 'address', label: 'Address', testId: 'worker-address-input', placeholder: 'Enter address' },
  { key: 'id_proof', label: 'ID Number', testId: 'worker-idproof-input', placeholder: 'Passport / National ID / SSN / Aadhaar etc.' },
  { key: 'emergency_contact', label: 'Emergency Contact', testId: 'worker-emergency-input', placeholder: 'Emergency contact number' }
];

export const WorkerFormDialog = ({
  open,
  onOpenChange,
  onAddClick,
  editingWorker,
  formData,
  setFormData,
  onSubmit,
  isSubmitting,
  symbol
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button
        onClick={onAddClick}
        data-testid="add-worker-btn"
        className="h-12 px-6 bg-[#2E4632] hover:bg-[#1F3122] text-white font-semibold"
      >
        <Plus className="w-5 h-5 mr-2" />
        Add Worker
      </Button>
    </DialogTrigger>
    <DialogContent className="sm:max-w-md max-h-[92vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-[#1C1C1E]" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {editingWorker ? 'Edit Worker' : 'Add New Worker'}
        </DialogTitle>
        <DialogDescription className="text-[#5C5C5C]">
          Name, phone and daily wage are required. Everything else is optional.
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4 mt-4">
        {fields.map((field) => (
          <div className="space-y-2" key={field.key}>
            <Label htmlFor={field.key}>
              {field.key === 'daily_wage' ? `Daily Wage (${symbol}) *` : field.label}
            </Label>
            <Input
              id={field.key}
              data-testid={field.testId}
              type={field.type || 'text'}
              value={formData[field.key]}
              onChange={(e) => setFormData({ ...formData, [field.key]: e.target.value })}
              placeholder={field.placeholder}
              className="h-12 border-[#D1D1CD]"
            />
          </div>
        ))}

        <div className="flex gap-3 pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="flex-1 h-12 border-[#D1D1CD]"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            data-testid="worker-submit-btn"
            disabled={isSubmitting}
            className="flex-1 h-12 bg-[#2E4632] hover:bg-[#1F3122] text-white"
          >
            {(() => {
              if (isSubmitting) return 'Saving...';
              return editingWorker ? 'Update' : 'Add Worker';
            })()}
          </Button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);
